import {requestWithKey} from "@/utils/request";
import endpoint from "@/config/endpoint";

export default {
  postRegistrationVerification: async(payload) => {
    try {
      const {phoneNumber} = payload
      const res = await requestWithKey.post(`${endpoint.MEMBER.REGISTRATION_VERIFICATION.POST}?account=${phoneNumber}`, null);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
};
